import { render, staticRenderFns } from "./AppPromotionalModal.vue?vue&type=template&id=5210e75a&scoped=true"
import script from "./AppPromotionalModal.vue?vue&type=script&lang=js"
export * from "./AppPromotionalModal.vue?vue&type=script&lang=js"
import style0 from "./AppPromotionalModal.vue?vue&type=style&index=0&id=5210e75a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5210e75a",
  null
  
)

export default component.exports